import { render, staticRenderFns } from "./SingleCheckboxFacet.vue?vue&type=template&id=13a93796&"
import script from "./SingleCheckboxFacet.vue?vue&type=script&lang=js&"
export * from "./SingleCheckboxFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports